<template>
    <LayoutBlock
        :tutorial_dialog="tutorial_dialog"
        @closeDialog="handleCloseDialog"
        >
        <div class="d-flex flex-column" v-if="measures">
            <div class="pl-2 pb-2 subtitle-1" v-if="conf.title" >{{conf.title}}</div>
            <v-container class="ma-0 pa-0">
                <v-row no-gutters>
                    <v-col cols="6">
                    <!-- componente a parte ha flag obbligatorio -->
                        <v-radio-group class="pa-0 ma-0" disabled v-model="measures.zero_device" label="Mantenimento dello zero">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                            <v-radio label="Fuori zona intervento" value="out"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="6" v-if="has_hi_res">
                        <!-- componente a parte ha flag obbligatorio e meccanico-->
                        <v-radio-group class="pa-0 ma-0" :disabled="preview" v-model="measures.hi_res" label="Alta risoluzione">
                            <v-radio label="Attivo" value="on"></v-radio>
                            <v-radio label="Disattivo" value="off"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row no-gutters v-if="!preview">
                    <div class="d-flex flex-shrink-1 flex-grow-0 py-2" v-if="!onlyPrimaries">
                        <v-btn @click="openWeightDialog">Scegli zavorra</v-btn>
                    </div>
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn color="primary" @click="handlePlaceholders">Inizio test</v-btn>
                        <v-btn class="ml-4" color="primary" @click="handleResetValues()">Reset</v-btn>
                    </div>
                </v-row>
                <v-row no-gutters>
                    <span class="subtitle-2"><b>Misure Asc.</b></span>
                </v-row>
                <v-row no-gutters>
                <v-simple-table class="measure_table">
                    <template v-slot:default>
                        <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-center">{{data.block.conf.headers.result}}</th>
                            </tr>
                        </thead>
                        <tr v-for="(item,index) of measures.items_up" :key="item.index+'_'+measures.weightTotal">
                            <td class="table-blocks d-flex align-center">
                                <v-icon class="d-flex flex-shrink-1 flex-grow-0" v-if="index >= conf.min_readings && !preview" @click="removeRow(index)">delete</v-icon>
                                <div v-else class="d-flex mr-6"></div>
                                <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{index + 1}}</div>
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.mass)"
                                @input="changeMass(item)" 
                                ></NumericField>
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :negative="false"
                                :class="readingWarning(item.reading)"
                                @input="changeLinearityReading(item, 'up')" 
                                :placeholder="readingPlaceholder(item.mass)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="calcMinRange(item.reading)"
                                ></NumericField>
                            </td>
                        
                            <td class="table-blocks with_scroll" v-if="measures.hi_res != 'on'">
                                <NumericField dense outlined
                                solo hide-details
                                class="text-left"
                                :readonly="preview"
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                @input="changeLinearityAddLoad(item, 'up')"
                                :placeholder="calculateAddLoadPlaceholder(item.reading)"
                                :class="addLoadWarning(item.addLoad, item.reading)"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="calcMinRange(item.reading)"
                                ></NumericField>
                            </td>
                            
                            <td class="table-text-blocks text-right" v-if="measures.hi_res != 'on'">
                                <b>{{item.p | formatNumber}}</b>
                            </td>
                            
                            <td class="table-text-blocks text-right">
                                <b>{{item.error | formatNumber}}</b>
                            </td>
                            
                            <td class="table-text-blocks text-right">
                                <b>{{item.error_corr | formatNumber}}</b>
                            </td>
                        
                            <td class="table-text-blocks text-right">
                                <b>{{item.mpe | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right">
                                <StatusIcon :status="item.result" :tooltip_text="row_tooltip[item.result]" />
                            </td>
                        </tr>
                    </template>
                </v-simple-table>
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                        <div v-if="addLoad_overflow_up" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                    </div>
                </v-row>
            
                <div class="d-flex flex-column" v-if="onlyPrimaries">
                <v-row no-gutters>
                    <span class="subtitle-2">Misure Disc.</span>
                </v-row>
                <v-row no-gutters>
                    <v-simple-table class="measure_table">
                        <template v-slot:default>
                            <thead class="expansion">
                            <tr>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.divs}}</th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mass}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.reading}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.addLoad}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right" v-if="measures.hi_res == 'off'">{{data.block.conf.headers.p}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.error_corr}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-right">{{data.block.conf.headers.mpe}} <br/><i class="caption">({{data.instrument_data.uom}})</i></th>
                                <th class="table-text-blocks text-center">{{data.block.conf.headers.result}}</th>

                            </tr>
                        </thead>
                        <tr v-for="(item,index) of measures.items_down" :key="item.index">
                            <td class="table-blocks d-flex align-center">
                                <div class="d-flex justify-center flex-shrink-0 flex-grow-1">{{index + 1}}</div>
                            </td>
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                hide-details
                                disabled
                                v-model="item.mass"
                                :precision="currentPrecision"
                                :negative="false"
                                ></NumericField>
                            </td>
                        
                            <td class="table-blocks with_scroll">
                                <NumericField dense outlined
                                solo hide-details
                                :readonly="preview"
                                v-model="item.reading"
                                :precision="currentPrecision"
                                :disabled="index == 0"
                                :negative="false"
                                class="text-left"
                                :class="readingWarning(item.reading, currMaxRange)"
                                @input="changeReading(item, currMaxRange)" 
                                :placeholder="readingPlaceholder(item.mass)"
                                :enableicons="!preview"
                                :addfunc="readingAddFunc"
                                :subfunc="readingSubFunc"
                                :row="item"
                                :fieldname="'reading'"
                                :range="currMaxRange"
                                ></NumericField>
                            </td>
                        
                            <td class="table-blocks with_scroll" v-if="measures.hi_res != 'on'">
                                <NumericField dense outlined
                                solo hide-details
                                class="text-left"
                                :readonly="preview"
                                :disabled="index == 0"
                                v-model="item.addLoad"
                                :precision="high_precision"
                                :negative="false"
                                @input="changeAddLoad(item, currMaxRange)"
                                :placeholder="calculateAddLoadPlaceholder(item.reading, currMaxRange)"
                                :class="addLoadWarning(item.addLoad, item.reading, currMaxRange)"
                                :enableicons="!preview"
                                :addfunc="loadAddFunc"
                                :subfunc="loadSubFunc"
                                :row="item"
                                :fieldname="'addLoad'"
                                :range="currMaxRange"
                                ></NumericField>
                            </td>
                        
                            <td class="table-text-blocks text-right" v-if="measures.hi_res != 'on'">
                                <b>{{item.p | formatNumber}}</b>
                            </td>
                            
                            <td class="table-text-blocks text-right">
                                <b>{{item.error | formatNumber}}</b>
                            </td>
                        
                            <td class="table-text-blocks text-right">
                                <b>{{item.error_corr | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right">
                                <b>{{item.mpe | formatNumber}}</b>
                            </td>
                            <td class="table-text-blocks text-right">
                                <StatusIcon :status="item.result" :tooltip_text="row_tooltip[item.result]" />
                            </td>
                        </tr>
                    </template>
                    </v-simple-table>
                </v-row>
                </div>
                <v-row no-gutters v-if="onlyPrimaries">
                    <div class="d-flex flex-column flex-grow-1 flex-shrink-0 table-bordered ma-2">
                        <div v-if="precision_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla valori e precisione letture</b></div>
                        <div v-if="addLoad_overflow_down" class="d-flex error--text caption"><StatusIcon status="failed" small /><b>Controlla carico addizionale</b></div>
                    </div>       
                </v-row>
                <v-row no-gutters>
                    <div class="d-flex flex-shrink-0 flex-grow-1 justify-end py-2">
                        <v-btn v-if="checkStatic && !preview" color="primary" @click="addRow"><v-icon class="pa-2">add_box</v-icon>aggiungi misura</v-btn>
                    </div>
                </v-row>
            </v-container>                
            </div>
            <WeightDialog
            ref="weightDialogRef"
            :data="weightDialogData"
            @changedWeight="changeRows"
            />
    </LayoutBlock>
</template>
<script>
import {linearity_item_new} from "../../../utils/itemBlockSchema"
import {BaseLeg} from "../../../utils/baseLeg"
import WeightDialog from "../../../components/dialogs/WeightDialog"
import LayoutBlock from "../../../components/utils/LayoutBlock"
import StatusIcon from "../../../components/utils/StatusIcon"
// import _ from 'lodash'
import Big from "big.js"

export default {
    components: {LayoutBlock, StatusIcon, WeightDialog},    
    mixins:[BaseLeg],
    data(){
        return{
            pagination: {'rowsPerPage': -1},
            items: [],
            currMaxRange: null,
            weightDialogData: {
                dialog: false,
                totalMass: 0,
                maxRange: 0,
                commonData: null
            }
        }
    },

    computed: {
        precision_overflow_up() {
            for (let elm of this.measures.items_up) {
                let res = this.checkReading(elm.reading)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        },
        precision_overflow_down() {
            let range = this.instrument_data.custom_data.multiext ? this.currMaxRange : null
            for (let elm of this.measures.items_down) {
                let res = this.checkReading(elm.reading, range)
                switch (res) {
                    case 'uncomplete':
                    case 'done':
                        break
                    case 'failed':
                        return true
                }
            }
            return false
        },
        addLoad_overflow_up() {
            if (this.measures.hi_res == 'off') {
                for (let elm of this.measures.items_up) {
                    if (!this.checkLoad(elm.addLoad, elm.reading)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        },
        addLoad_overflow_down() {
            if (this.measures.hi_res == 'off') {
                let range = this.instrument_data.custom_data.multiext ? this.currMaxRange : null
                for (let elm of this.measures.items_down) {
                    if (!this.checkLoad(elm.addLoad, elm.reading, range)) {
                        return true
                    }
                } return false
            } else {
                return false
            }
        }
        
        
    },
    methods: {
        openWeightDialog(){
            this.weightDialogData.totalMass = this.calculateTotal
            this.weightDialogData.maxRange = this.findMaxRange().max
            this.weightDialogData.commonData = this.getCommonData()
            this.weightDialogData.uom = this.instrument_data.uom
            this.$refs.weightDialogRef.setOldWeight(this.measures.weightTotal)
            this.$refs.weightDialogRef.dialog = true
        },

        addRow(){
            let item = linearity_item_new({
                index: this.measures.startingIndex
            })
            let item_down = linearity_item_new({
                index: this.measures.startingIndex
            })
            this.measures.startingIndex++
            this.measures.items_down.unshift(item_down)
            this.measures.items_up.push(item)
        },
        
        async buildMeasures(){
            this.measures = {
                items_up: [],
                items_down: [],
                zero_device: this.conf.zero_device,
                hi_res: this.conf.hi_res,
                weightTotal: 0,
                startingIndex: 0,
                result: 'uncomplete'
            }
            this.measures.hi_res = this.has_hi_res ? this.conf.hi_res : 'off'
            this.measures.startingIndex = this.data.block.conf.min_readings
            let catVals = await this.buildWithCategory()
            if(catVals){
                for (let i = 0; i< catVals.length; i++ ){
                    let currCatVal = catVals[i]
                    let currMpe = this.calc_MPE(this.calcMinRange(currCatVal), currCatVal)
                    let currMpeDown = this.instrument_data.custom_data.multiext ? this.calc_MPE(this.currMaxRange, currCatVal) : currMpe
                    let item = linearity_item_new({
                        index: i,
                        mass: currCatVal,
                        mpe: currMpe
                    })
                    let item_down = linearity_item_new({
                        index: i,
                        mass: currCatVal,
                        mpe: currMpeDown
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
                this.calculateMaxRange()
            } else {
                for (let i = 0; i< this.data.block.conf.min_readings; i++ ){
                    let item = linearity_item_new({
                        index: i,
                        mass: "0",
                        mpe: "0"
                    })
                    let item_down = linearity_item_new({
                        index: i,
                        mass: "0",
                        mpe: "0"
                    })
                    this.measures.items_up.push(item)
                    this.measures.items_down.unshift(item_down)
                }
            }
        },
        findRow(items, index){
            return items.find(function(a){
                return a.index == index
            })
        },
    
        calculateMaxRange(){
            if (this.instrument_data.custom_data.multiext){
                let maxItem = this.measures.items_up.reduce((acc, val) => {
                    acc = ( acc === undefined || Big(val.mass).gt(acc.mass)) ? val : acc
                    return acc;
                }, {mass: 0})
                this.currMaxRange = this.calcMinRange(maxItem.mass)
            } else {
                this.currMaxRange = null
            }
        },     
        changeMass(row){
            if(row.mass){
                let range = this.calcMinRange(row.mass)
                row.mpe = this.calc_MPE(range, row.mass)
                if(this.onlyPrimaries){
                    let row_down = this.findRow(this.measures.items_down, row.index)
                    row_down.mass = row.mass
                    this.calculateMaxRange()
                    if(this.instrument_data.custom_data.multiext){
                        row_down.mpe = this.calc_MPE(this.currMaxRange, row.mass)
                    } else {
                        row_down.mpe = row.mpe
                    }
                }
            }
        },

        
        calcError(row, range = null){
            if (row.reading != null && row.reading != ''){
                if(this.measures.hi_res == 'on'){
                    row.error = this.differenceInt(row.reading, row.mass)
                    this.calculateResult(row)
                } else {
                    if(row.addLoad != null && row.addLoad != ''){
                        row.error = this.differenceInt(row.p, row.mass)
                        if(this.checkLoad(row.addLoad, row.mass, range)){
                            this.calculateResult(row, range)
                        } else {
                            row.result = 'failed'
                        }
                    } else {
                        row.result = "uncomplete"
                    }
                } 
            } else {
                row.result = 'uncomplete'
            }
        },
        calcDiff(){
            let start_error = null
            for(let i=0; i<this.measures.items_up.length;i++){
                let row = this.measures.items_up[i]
                this.calcError(row)
                if(i == 0){
                    start_error = row.error
                } else {
                    row.error_corr = this.differenceInt(row.error, start_error)
                }
            }
            for(let i=0; i<this.measures.items_down.length;i++){
                let row = this.findRow(this.measures.items_down, i)
                if(row){
                    this.calcError(row, this.currMaxRange)
                    if(i == 0){
                        start_error = row.error
                    } else {
                        row.error_corr = this.differenceInt(row.error, start_error)
                    }
                }
            }
        },
        saveFirst(){
            
        },
        handlePlaceholders(){
            this.convertPlaceholders(this.measures.items_up)
            if(this.instrument_data.custom_data.multiext){
                this.calculateMaxRange()
                this.convertPlaceholders(this.measures.items_down, this.currMaxRange)
            } else {
                this.convertPlaceholders(this.measures.items_down)
            }
        },
        handleResetValues() {
            this.resetValues(this.measures.items_up)
            this.resetValues(this.measures.items_down)
        },
        saveMeasures() {
            let block = this.data.block
            let temp = []
            temp.push(this.measures.items_up[0])
            temp.push(this.measures.items_up[this.measures.items_up.length -1])
            this.calcBlockResult()
            if(this.data.common_data[block.name]){
                this.data.common_data[block.name][block._id].value = temp
            }
            this.$parent.$emit('updateMeasure', {b_index: this.data.b_index, measures: this.measures, p_idx: this.data.p_idx, p_id: this.data.p_id, common_data: this.data.common_data })
        },
        removeRow(index){
            // console.log("$$ remove row", index, this.measures.items_down.length - index - 1, this.measures.items_down)
            let item = this.measures.items_up.splice(index,1)
            let item_down = this.measures.items_down.splice(this.measures.items_down.length - index - 1,1)
            console.log("$$ item removed", item, item_down)
        },
        calcBlockResult() {
            // console.log('CALC BLOCK RESULT')
            let result_up = 'done'
            result_up = this.measures.items_up.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            let result_down = 'done'
            result_down = this.measures.items_down.reduce(function(result, item){
                let res = 'done'
                switch (item.result) {
                    case 'uncomplete':
                        res = 'uncomplete'
                        break
                    case 'failed':
                        if (result == 'uncomplete') {
                            res = 'uncomplete'
                        } else {
                            res = 'failed'
                        }
                        break
                    case 'done':
                        res = result
                        break
                }
                return res
            }, 'done')
            // console.log('CALC BLOCK RESULT', result_up, result_down)
            if (result_up == result_down && result_up == "done") {
                if(this.precision_overflow_up || this.precision_overflow_down){
                    this.measures.result = 'failed' 
                } else if(this.measures.hi_res == 'off' && (this.addLoad_overflow_up || this.addLoad_overflow_down) ){
                    this.measures.result = 'failed'
                } else {
                    this.measures.result = result_up
                }
            }  else if (result_up == 'uncomplete' || result_down == 'uncomplete') {
                this.measures.result = 'uncomplete'
            } else if (result_up == 'failed' || result_down == 'failed') {
                this.measures.result = 'failed'
            }
            // console.log('CALC BLOCK RESULT', result_up, result_down, this.measures.result)
        },
    }
 
}
</script>
